import { schema, normalize } from 'normalizr';
import { fileComponentKey } from '../helpers/reducers';

const userSchema = new schema.Entity('followers', {}, { idAttribute: 'userId' });
//const followers = new schema.Array(userSchema);

export const caseSchema = new schema.Entity('cases', {}, { idAttribute: 'caseId' });
export const casesSchema = new schema.Array(caseSchema);

const eventSchema = new schema.Entity('calendar', {}, { idAttribute: 'eventId' });
export const eventsSchema = new schema.Array(eventSchema);

export const followersSchema = new schema.Array(userSchema);

const employerEventSchema = new schema.Entity('employerCalendar', {}, { idAttribute: 'eventId' });
export const employerEventsSchema = new schema.Array(employerEventSchema);

export const topicSchema = new schema.Entity('topics', {}, { idAttribute: 'topicId' });
export const topicsSchema = new schema.Array(topicSchema);

export const consultSchema = new schema.Entity(
  'consults',
  {},
  { idAttribute: 'consult_request_id' }
);
export const consultsSchema = new schema.Array(consultSchema);
export const notificationSchema = new schema.Entity(
  'notifications',
  {},
  { idAttribute: 'notificationId' }
);
export const notificationsSchema = new schema.Array(notificationSchema);

export const entitiesSchema = new schema.Entity('entities', {
  cases: casesSchema,
  topics: topicsSchema,
});

export const patientSchema = new schema.Entity('patients', {}, { idAttribute: 'patientId' });
export const patientsSchema = new schema.Array(patientSchema);

export const roleSchema = new schema.Entity('roles', {}, { idAttribute: 'role' });
export const rolesSchema = new schema.Array(roleSchema);

export const employerSchema = new schema.Entity('employers', {}, { idAttribute: 'employerId' });
export const employersSchema = new schema.Array(employerSchema);

function _mapParticipant(map, p) {
  map[p.userId] = {
    userId: p.userId,
    roleId: p.roleId,
    updated: p.updatedParticipant,
    isMedicalTeam: p.isMedicalTeam,
  };
  return map;
}

export function normalizeCases(cases, isArray = true, skipParticipants = false) {
  let casesNormalized = normalize(cases, isArray ? casesSchema : caseSchema);

  //Change participants to dictionary with roleId TODO: see if we can do this directly on casesSchema.
  if (isArray) {
    if (!skipParticipants) {
      cases.forEach((c) => {
        casesNormalized.entities.cases[c.caseId].participants = c.participants.reduce(
          _mapParticipant,
          {}
        );
      });
    }
  } else {
    casesNormalized.entities.cases[casesNormalized.result].participants = cases.participants.reduce(
      _mapParticipant,
      {}
    );
  }

  return casesNormalized;
}

export function normalizeFollowers(followers) {
  const followersNormalized = normalize(followers, followersSchema);
  followers.forEach((f) => {
    const normalizedEmployers = normalize(f.employers, employersSchema);
    followersNormalized.entities.followers[f.userId].employers =
      normalizedEmployers.entities.employers;
  });

  return followersNormalized;
}

export function normalizeEvents(events) {
  return normalize(events, eventsSchema);
}

export function normalizeEmployerEvents(events) {
  return normalize(events, employerEventsSchema);
}

export function normalizeTopics(topics) {
  topics.forEach((topic) => {
    if (topic.messages.length > 0) {
      const messages = topic.messages.reduce((map, m) => ((map[m.messageId] = m), map), {});
      topic.messages = messages;
    } else {
      topic.messages = {};
    }
  });
  //Normalize topics
  const topicsNormalized = normalize(topics, topicsSchema);
  return topicsNormalized;
}

export function normalizePatients(patients, isArray = true) {
  if (!patients && !isArray)
    return {
      entities: {
        patients: {},
      },
    };

  const patientsNormalized = normalize(patients, isArray ? patientsSchema : patientSchema);
  return patientsNormalized;
}

export function normalizeFiles(files) {
  const filesNormalized = files.reduce(
    (map, f) => (
      (map[fileComponentKey({ objectType: f.objectType, objectId: f.objectId })] = f),
      map
    ),
    {}
  );
  console.log('normalizeFiles', filesNormalized);
  return filesNormalized;
}
